// Salon Privé · PRSNL — Sabril · Audit resto DA
// Warm ivory + deep forest green + gold — editorial Mediterranean
// Values inherit from /theme/sabril-da.js (single source of truth)

import { DA } from '../theme/sabril-da';

export const salonPriveTheme = {
  // ── Backgrounds (ivory palette) ───────────────────────────────────
  bg: DA.ivory,               // page bg — warm ivory
  bgPaper: DA.paper,          // white paper card
  bgSecondary: DA.ivoryDeep,  // banded sections
  bgTertiary: DA.ivoryLight,  // subtle off-ivory

  // ── Ink palette ───────────────────────────────────────────────────
  ink: DA.greenDeep,          // primary title colour = deep forest green
  inkDeep: DA.greenDeep,      // was iOS #1C1C1E — now brand green
  inkBrand: DA.greenDeep,
  inkBody: DA.ink,            // body copy — warm dark brown
  inkMuted: DA.inkMuted,

  // ── Brand accent — gold ──────────────────────────────────────────
  gold: DA.goldMain,
  goldSoft: DA.goldSofter,
  goldBorder: DA.goldSoft,

  // Navy retained for very rare accent moments
  navy: DA.greenDeep,
  navyDeep: '#06132A',

  // ── Borders & dividers ───────────────────────────────────────────
  hairline: DA.goldSoft,
  hairlineStrong: 'rgba(216,148,64,0.35)',
  dashed: 'rgba(216,148,64,0.45)',

  // ── Shadows ──────────────────────────────────────────────────────
  shadowSm: '0 1px 2px rgba(11,43,36,0.04), 0 0 0 0.5px rgba(216,148,64,0.10)',
  shadowMd: '0 4px 16px rgba(11,43,36,0.06), 0 1px 3px rgba(11,43,36,0.04)',
  shadowLg: '0 12px 40px rgba(11,43,36,0.10), 0 2px 6px rgba(11,43,36,0.05)',
  shadowWallet: '0 20px 50px -12px rgba(11,43,36,0.28), 0 8px 16px -8px rgba(11,43,36,0.10)',

  // ── Typography ───────────────────────────────────────────────────
  fontDisplay: DA.serif,      // Playfair Display for headings
  fontSerif: DA.serif,
  fontSans: DA.sans,
  fontMono: DA.mono,

  // ── Wallet card palette (retained for KPI cards / pillars) ───────
  wallet: DA.wallet,

  // ── Motion ───────────────────────────────────────────────────────
  easeRefined: DA.easeRefined,
  transitionBase: DA.transition,

  // ── Radii ────────────────────────────────────────────────────────
  radiusSm: DA.radiusSm,
  radiusMd: DA.radiusMd,
  radiusLg: DA.radiusLg,
  radiusXl: DA.radiusXl,
};

export default salonPriveTheme;
